import React, { useState } from 'react';
import Styles from '../../assets/css/auth/resetPassword.module.scss';
import { useNavigate } from 'react-router-dom';
import ForgotPasswordLogo from '../../assets/images/logo/Forgot_password.png';
import { IoArrowBack } from "react-icons/io5";
import { adminForgotPass } from '../../services/Api';
import { AiOutlineLoading } from 'react-icons/ai';
import { useDispatch } from 'react-redux';
import { popUpBoxTrigger } from "../../features/message/popUpSlice";
import PopUpMessage from "../../utils/errors/PopUpMessage";
import { responseHandler } from '../../utils/responseHandler';

const ForgotPassword = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');

    const showPopup = (type, heading, message) => {
        dispatch(popUpBoxTrigger({
            type,
            heading,
            message,
            show: true
        }));
    };

    const validateEmail = (email) => {
        const emailRegex = /\S+@\S+\.\S+/;
        if (!email) {
            return "Email is required";
        }
        if (!emailRegex.test(email)) {
            return "Please enter a valid email address";
        }
        return "";
    };

    const handleResetPassword = async () => {
        const emailError = validateEmail(email);
        if (emailError) {
            setError(emailError);
            return;
        }
    
        setLoading(true);
        try {
            const response = await adminForgotPass({ email });
            
            // Check if the response contains the specific mail server error
            if (response.exception && response.exception.includes('TransportException')) {
                showPopup('error', 'Service Unavailable', 
                    'Email service is temporarily unavailable. Please try again later or contact support.');
                return;
            }

            const result = await responseHandler(response);
    
            if (result.status === 200) {
                showPopup('success', 'Email Sent', 'Verification code has been sent to your email.');
                await new Promise(resolve => setTimeout(resolve, 1000));
                navigate("/otpVerify", { state: { 
                    email: email,
                    fromForgotPassword: true 
                } 
            });
            } else {
                // Handle other API response statuses
                const errorMessage = result.message || 'Failed to process your request.';
                showPopup('error', 'Error', errorMessage);
            }
    
        } catch (error) {
    
            // Handle different types of errors
            if (!navigator.onLine) {
                showPopup('error', 'Connection Error', 'Please check your internet connection.');
            } else if (error.response) {
                // Check for the specific mail server error in the error response
                if (error.response.data && 
                    error.response.data.exception && 
                    error.response.data.exception.includes('TransportException')) {
                    showPopup('error', 'Service Unavailable', 
                        'Email service is temporarily unavailable. Please try again later or contact support.');
                } else {
                    // Handle other API errors
                    const errorMessage = error.response.data.message || 'Something went wrong.';
                    showPopup('error', 'Error', errorMessage);
                }
            } else {
                showPopup('error', 'Error', 'Unable to connect to the server.');
            }
        } finally {
            setLoading(false);
        }
    };
    

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleResetPassword();
        }
    };

    return (
        <div className={`${Styles.container}`}>
            <PopUpMessage />
            
            <div className={`${Styles.resetBox}`}>
                <img src={ForgotPasswordLogo} alt="forgot password" />
                <h2 className={`${Styles.title}`}>Forgot password?</h2>
                <p className={`${Styles.subtitle}`}>Please enter your email address to receive a verification code.</p>

                <div className={`${Styles.form}`}>
                    <div className={`${Styles.inputGroup} ${error ? Styles.error : ''}`}>
                        <label>Email</label>
                        <input 
                            id="email"
                            name="email"
                            type="email" 
                            placeholder="Enter Your Email"
                            value={email}
                            onChange={(e) => {
                                setEmail(e.target.value);
                                setError('');
                            }}
                            onKeyPress={handleKeyPress}
                        />
                        {error && <span className={Styles.errorMessage}>{error}</span>}
                    </div>
                    <button onClick={handleResetPassword} className={`${Styles.forgotPasswordButton}`} disabled={loading}>
                        {loading ? <AiOutlineLoading /> : "Send"}
                    </button>
                </div>
            </div>

            <div className={`${Styles.back_to_login}`}>
                <a href="/login"><IoArrowBack /> Back to log in</a>
            </div>
        </div>
    )
}

export default ForgotPassword;
